import React, { useEffect } from 'react';
import { observer } from 'mobx-lite';
import { Box, Stack, Typography } from '@mui/material';
import { MainStoreContextItem } from '../../Stores/MainStore';
import { VideoDisplay } from '../Cam/VideoDisplay';
import { VideoDisplayPlaceHolder } from '../Cam/VideoPlaceHolder';
import { GuardResultOverlay } from './GuardResultOverlay';

export const GuardScreen: React.FC = observer(() => {
    const store = MainStoreContextItem.useStore();
    const { permissionGranted, stream } = store.mediaDeviceStore;
    const { guardNeutralDetector } = store.settingsStore;
    const { guardModeStore, faceServiceStore, eventThemesStore } = store;

    useEffect(() => {
        store.mediaDeviceStore.getMediaDevices();
    }, [store.mediaDeviceStore]);

    const notConfigured = !guardNeutralDetector.trim();

    return (
        <Box sx={{ position: 'relative', width: '100%', height: '100vh', backgroundColor: '#000' }}>
            {permissionGranted && stream ? <VideoDisplay stream={stream} /> : <VideoDisplayPlaceHolder />}

            {notConfigured && (
                <Stack sx={{ position: 'absolute', inset: 0, alignItems: 'center', justifyContent: 'center', zIndex: 1150, background: 'rgba(0,0,0,0.7)' }}>
                    <Typography variant="h6" color="warning.main">Guard Mode not configured</Typography>
                    <Typography color="text.secondary">Set a Neutral detector in Setup → Guard Mode.</Typography>
                </Stack>
            )}

            <GuardResultOverlay
                result={guardModeStore.result}
                visible={guardModeStore.resultVisible}
                eventThemesStore={eventThemesStore}
                canIn={!!guardModeStore.inDetector}
                canOut={!!guardModeStore.outDetector}
                showIgnore={store.settingsStore.guardShowIgnoreButton}
                onIn={() => guardModeStore.recordIn()}
                onIgnore={() => guardModeStore.ignore()}
                onOut={() => guardModeStore.recordOut()}
                onOverlayActiveChanged={(active) => faceServiceStore.setEventOverlayActive(active)}
            />
        </Box>
    );
});

GuardScreen.displayName = 'GuardScreen';
